const defaultForm = () => ({
  status_up: 2,
  qr_image: '',
  qr_code: '',
  bank_name: '',
  branch_name: '',
  finance_id: '',
});

export default {
  props: {
    visible: Boolean,
    data: Object,
    financeList: {
      type: Array,
      default: () => [],
    },
    typeCode: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      form: defaultForm(),
      loading: false,
      isUpdate: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => this.initForm());
        }
      },
    },
    data() {
      if (this.visible) {
        this.$nextTick(() => this.initForm());
      }
    },
  },
  methods: {
    initForm() {
      if (this.data) {
        this.form = Object.assign(defaultForm(), this.data);
        if (this.form.finance_id === 0 || this.form.finance_id === '0' || this.form.finance_id === '') {
          this.form.finance_id = '';
        } else {
          this.form.finance_id = Number(this.form.finance_id);
        }
        this.isUpdate = true;
      } else {
        this.form = Object.assign(defaultForm(), { finance_id: '' });
        this.isUpdate = false;
      }
      this.form.type_code = this.typeCode || this.form.type_code;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    onQrUpload(data) {
      if (data && typeof data === 'object') {
        if (data.qr_code !== undefined) {
          this.form.qr_code = data.qr_code;
        }
        if (data.qr_image !== undefined) {
          this.form.qr_image = data.qr_image;
        }
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField('qr_image');
        }
      });
    },
    buildPayload(extra = {}) {
      const financeId = this.form.finance_id !== '' && this.form.finance_id != null && this.form.finance_id !== 0
        ? Number(this.form.finance_id)
        : 0;
      return {
        ...this.form,
        finance_id: financeId,
        type_code: this.typeCode || this.form.type_code,
        ...extra,
      };
    },
    save(payload) {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        this.$http
          .post('/resourcecolumn/editTo', payload)
          .then((res) => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              if (!this.isUpdate) {
                this.form = defaultForm();
              }
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
  },
};
